var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TopBotLayout',{scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('Header')]},proxy:true},{key:"bot",fn:function(){return [_c('CompletionTable')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }